import { Component, OnInit } from '@angular/core';
import { 
  SuppliersService,
  SharedDataService,
  SupplierPilotageDepens
 } from 'ngx-paf-common';
import { PilotageEndelTabComponent } from '../pilotage-endel-tab/pilotage-endel-tab.component';

@Component({
  selector: 'pilotage-depenses',
  templateUrl: './pilotage-depenses.component.html',
  styleUrls: ['./pilotage-depenses.component.scss']
})
export class PilotageDepensesComponent
  extends PilotageEndelTabComponent 
 implements OnInit {
  reloadTab(): void {
    this.refreshDepenses();
  }

  lstDepenses: SupplierPilotageDepens[]=[];

  constructor(
    public sharedDataSvc:SharedDataService,
    private suppliersSvc:SuppliersService
  ) { 
    super(sharedDataSvc);
  }

  refreshDepenses():void{
    this.sharedDataSvc.WindowLock();
    this.suppliersSvc.GetPilotageDepenses(this.supplierId)
    .subscribe(res=>{
      this.lstDepenses = res;
      this.lstDepenses.sortObject('Annee');
    },
    (reason:any)=> this.sharedDataSvc.alert(reason.error.Message)
    ,()=> this.sharedDataSvc.WindowUnlock());
  }
  ngOnInit(): void {
    this.refreshDepenses();
  }


}
